import { sendToMixpanel, getUserProps } from '..';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';
import type { Option } from '../../components/search-autocomplete/types';

export interface SelectSearchSuggestionParams {
  item: Pick<Option, 'category' | 'label' | 'value'>;
  position: number;
  textTyped: string;
  totalSuggestions?: number;
  modules?: FaaLandingPageModule[];
}

const trackSelectSearchSuggestion = ({
  item,
  position,
  textTyped,
  totalSuggestions,
  modules = getVisibleLandingPageModules(),
}: SelectSearchSuggestionParams): void => {
  sendToMixpanel('Select Search Suggestion', {
    siteSection: 'Agents',
    suggestionCategory: item.category,
    suggestionPosition: position,
    suggestionTextTyped: textTyped,
    suggestionLabel: item.label,
    suggestionValue: item.value,
    ...(totalSuggestions !== undefined && {
      suggestionSelectionCount: totalSuggestions,
    }),
    modules,
    modulesCount: modules.length,
    ...getUserProps(),
  });
};

export default trackSelectSearchSuggestion;
